import { render } from "./_code.vue?vue&type=template&id=55190bb8&ts=true"
import script from "./_code.vue?vue&type=script&lang=ts"
export * from "./_code.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__